import React from "react";
import { Link } from "react-router-dom";
import jwtDecode from "jwt-decode";

import "./Hero.css";

const Hero = () => {
  let user;
  try {
    const token = localStorage.getItem("token");
    user = jwtDecode(token);
  } catch (error) {
    console.log(error);
  }
  return (
    <div className="hero">
      <div className="hero__box">
        <h1 className="hero__title">FoodGy</h1>
        <p className="hero__desc">order you faivort food in one click</p>
      
        {!user && (
          <div className="hero__button">
            <Link to="/signup" className="btn-start m-r-s link">
              Signup
            </Link>
            <Link to="/login" className="btn-start-login link">
              Login
            </Link>
          </div>
        )}

        {user && (
          <div className="hero__button">
            <Link to="/foods" className="btn-start m-r-s link">
              Order Now
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Hero;
